import { getUserId } from '@/infrastructure/auth';
import { getParamFromUrl } from '@/infrastructure/history';
import { storageGet } from '@/infrastructure/storage-utils';
import { Platform } from '@/infrastructure/utils/app';
import { stores } from '@/presentation/store';

// 获取改版后的string类型的Id
export function getProductId() {
  return stores.ProductStore.productId
    || getParamFromUrl('productId')
    || storageGet(`${getUserId()}-productId`)
    || '';
}

// 获取当前产品名称
export function getProductName() {
  return stores.ProductStore.product?.productName;
}

// 获取当前平台类型 1,2,4...
export function getPid() {
  // 兼容不同协议返回的pid，有的是number，有的是string，这里统一转字符串
  return stores?.ProductStore?.pid ? `${stores.ProductStore.pid}` : '';
}

// 获取当前平台类型 android,ios,flutter..
export function getPlatform() {
  const { pid, isFlutter } = stores.ProductStore;
  const pidMap: Record<string, string> = {
    ['1']: 'android',
    ['2']: 'ios',
    ['4']: 'mac',
    ['10']: 'windows',
    ['17']: 'VisionOS',
    [`${Platform.HarmonyOS}`]: 'Harmony',
    [`${Platform.Hippy}`]: 'Hippy',
    [`${Platform.Kuikly}`]: 'Kuikly',
    // todo 可能要改
    [`${Platform.MiniProgram}`]: 'MiniProgram',
  };
  return !isFlutter ? (pidMap[pid] || '') : 'flutter';
}

export function getCapitalPlatform() {
  const { pid, isFlutter } = stores.ProductStore;
  const pidMap: Record<string, string> = {
    [Platform.Android]: 'Android',
    [Platform.IOS]: 'IOS',
    [Platform.Mac]: 'Mac',
    [Platform.Windows]: 'Windows',
    [Platform.HarmonyOS]: 'Harmony',
    [Platform.Hippy]: 'Hippy',
    [Platform.VisionOS]: 'VisionOS',
    [Platform.Kuikly]: 'Kuikly',
    // todo 可能要改
    [Platform.MiniProgram]: 'MiniProgram',
  };
  return !isFlutter ? (pidMap[pid] || '') : 'Flutter';
}

export function getTagCapitalPlatform() {
  const { pid, isFlutter } = stores.ProductStore;
  const pidMap: Record<string, string> = {
    [Platform.Android]: 'Android',
    [Platform.IOS]: 'iPhone',
    [Platform.Mac]: 'Mac',
    [Platform.Windows]: 'Windows',
    [Platform.HarmonyOS]: 'Harmony',
    [Platform.Hippy]: 'Hippy',
    [Platform.Kuikly]: 'Kuikly',
    [Platform.VisionOS]: 'VisionOS',
  };
  return !isFlutter ? (pidMap[pid] || '') : 'Flutter';
}

export function isMiniprogram() {
  return getPid() === `${Platform.MiniProgram}`;
}

export function isKuikly() {
  return getPid() === '15';
}

export function isHippy() {
  return getPid() === '14';
}

export function isAndroid() {
  return getPid() === '1';
}

export function isIOS() {
  return getPid() === '2';
}

export function isApple() {
  return isIOS() || isVisionOS() || isMac();
}

export function isFlutter() {
  return stores.ProductStore.isFlutter;
}

export function isMac() {
  return getPid() === '4';
}

export function isWindows() {
  return getPid() === '10';
}

export function isHarmonyOS() {
  return getPid() === `${Platform.HarmonyOS}`;
}

export function isVisionOS() {
  return getPid() === `${Platform.VisionOS}`;
}

export function getToolyAppId() {
  return stores.ProductStore.toolyAppId;
}
